import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const udpWriteUiNodeSpec: UiNodeSpec<'udpWrite'> = {
    requiredSockets: (node, availableInputSockets) => ({
        required: [],
        conditionallyRequired: [
            {
                kind: 'or',
                availableOptions: availableInputSockets,
            },
        ],
    }),
    cfg: () => ({ controlValues: { host: '', port: 1024 }, id: getUID(), kind: 'udpWrite', disabled: false }),
    controls: getNodeCfg => ({
        host: { cfg: { kind: 'text', label: 'IP' }, nodeCfg: getNodeCfg(), value: getNodeCfg().controlValues.host },
        port: { cfg: { kind: 'number', label: 'Port', min: 1024 }, nodeCfg: getNodeCfg(), value: getNodeCfg().controlValues.port },
    }),
    inputs: nodeCfg => ({
        trigger: { socket: 'event', label: 'Trigger' },
        payload: {
            control: {
                cfg: { kind: 'text', nullable: true, label: 'Payload' },
                nullable: true,
                nodeCfg,
                value: nodeCfg.socketDefaults?.inputs?.sendPayload,
            },
            socket: 'string',
        },
    }),
    kindLabel: 'UDP Write',
    nodeCategory: 'external',
    outputs: () => ({ next: { socket: 'event', label: 'Next' } }),
    validator: node => {
        const errors: Record<string, string> = {};
        if (!node.controlValues.port) {
            errors.port = 'Port is required';
        }
        if (!node.controlValues.host) {
            errors.host = 'IP is required';
        }
        return Object.keys(errors).length ? errors : true;
    },
};
